import AppLayout from '../../../../component/appLayout';
import TaskDetail from '../taskDetail';
import { Group } from './styles';

const TaskData: React.FC = () => {
  return (
    <>
      <AppLayout>
        <Group>
          <TaskDetail />
        </Group>
      </AppLayout>
    </>
  );
};

export default TaskData;
